var map = {
	"./aia.svg": 3031,
	"./ant.svg": 3032,
	"./aus.svg": 3033,
	"./bah.svg": 3034,
	"./ban.svg": 3035,
	"./bar.svg": 3036,
	"./ber.svg": 3037,
	"./biz.svg": 3038,
	"./bot.svg": 3039,
	"./bru.svg": 3040,
	"./can.svg": 3041,
	"./cay.svg": 3042,
	"./cmr.svg": 3043,
	"./cok.svg": 3044,
	"./cyp.svg": 3045,
	"./dma.svg": 3046,
	"./eng.svg": 3047,
	"./fij.svg": 3048,
	"./flk.svg": 3049,
	"./gab.svg": 3050,
	"./gam.svg": 3051,
	"./ggy.svg": 3052,
	"./gha.svg": 3053,
	"./gib.svg": 3054,
	"./grn.svg": 3055,
	"./guy.svg": 3056,
	"./ind.svg": 3057,
	"./iom.svg": 3058,
	"./ivb.svg": 3059,
	"./jam.svg": 3060,
	"./jey.svg": 3061,
	"./ken.svg": 3062,
	"./kir.svg": 3063,
	"./lca.svg": 3064,
	"./les.svg": 3065,
	"./manifest.json": 867,
	"./mas.svg": 3066,
	"./maw.svg": 3067,
	"./mdv.svg": 3068,
	"./mlt.svg": 3069,
	"./moz.svg": 3070,
	"./mri.svg": 3071,
	"./msr.svg": 3072,
	"./nam.svg": 3073,
	"./nfk.svg": 3074,
	"./ngr.svg": 3075,
	"./nir.svg": 3076,
	"./niu.svg": 3077,
	"./nru.svg": 3078,
	"./nzl.svg": 3079,
	"./pak.svg": 3080,
	"./png.svg": 3081,
	"./rsa.svg": 3082,
	"./rwa.svg": 3083,
	"./sam.svg": 3084,
	"./sco.svg": 3085,
	"./sey.svg": 3086,
	"./sgp.svg": 3087,
	"./shn.svg": 3088,
	"./skn.svg": 3089,
	"./sle.svg": 3090,
	"./sol.svg": 3091,
	"./sri.svg": 3092,
	"./svg-country.svg": 3093,
	"./swz.svg": 3094,
	"./tan.svg": 3095,
	"./tca.svg": 3096,
	"./tga.svg": 3097,
	"./tog.svg": 3098,
	"./tto.svg": 3099,
	"./tuv.svg": 3100,
	"./uga.svg": 3101,
	"./van.svg": 3102,
	"./wal.svg": 3103,
	"./zam.svg": 3104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3030;